import {
  getAnyonomousViewCount,
  defaultAvcCookieName,
} from './anonymous-view-tracker';

/**
 * Returns true if the popup should be shown to the user.
 *
 * @param cookieName - The name of the cookie to look into
 * @param countThreshold -  The count threshold to show the popup
 * @returns boolean.
 * Note: For testing purpose we needed to seperate this function from anonymous-view-tracker.ts,
 * so that getAnyonomousViewCount can be mocked.
 */
export function hasAnonymousViewCountExceeded(
  countThreshold: number,
  cookieName: string = defaultAvcCookieName
): boolean {
  const cookieValue = getAnyonomousViewCount(cookieName);
  return cookieValue >= countThreshold;
}
